import {Title} from "#app/interface/cabinet/header/Dropdown/styles";
import Dropdown from "#app/interface/cabinet/header/Dropdown/Dropdown";
import React from "react";
import {routes} from "#app/constants/routes";

const IncomeDropdown = ({i18n, data, handleMenu, url}) => {
  const condition2 = routes.incomeAndExpensesValidPaths.includes(url);

  const menuLinks = [
    { id: 'income-and-expenses-menu-0', link: routes.incomeAndExpenses.tactics, text: i18n.menu.dashboard },
    { id: 'income-and-expenses-menu-1', link: routes.incomeAndExpenses.income, text: i18n.menu.incomes },
    { id: 'income-and-expenses-menu-2', link: routes.incomeAndExpenses.spendings, text: i18n.menu.outcomes }
  ];

  return (
    <Dropdown
      id="dropdown-income-and-expenses"
      width="230px"
      containerId="dropdown-income-and-expenses-container"
      links={menuLinks}
    >
      <Title
        id="accounting-tab-2"
        className={condition2 ? 'active' : ''}
        onClick={(e) => handleMenu(e, routes.incomeAndExpenses.tactics)}
      >
        {i18n.menu.incomesOutcomes}
      </Title>
    </Dropdown>
  );
}

export default IncomeDropdown